import dateFormat from "dateformat";
import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import GameModel from "../model/GameModel";
import BaseEndScreenMediator from "../../../../../shared/src/ranj/equalture/view/BaseEndScreenMediator";

export default class EndScreenMediator extends BaseEndScreenMediator {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {GameModel} gameModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel, gameModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);
        this._gameModel = gameModel;
    }

    initialize() {
        // Racer has an additional "elapsed time" text field that the other games don't have
        const elapsed = this._gameModel.elapsedTime;
        const timeStr = dateFormat(new Date(elapsed), "MM:ss.L");
        this.applyText(this._target.textPanel.timeTextfield, this.getText("endOverlay.time", { time: timeStr }));

        super.initialize();
    }

    initializeTexts() {
        this.titleText = this.getText("endOverlay.title");
        this.bodyText = this.getText("endOverlay.body");
        this.buttonText = this.getText("endOverlay.button");
    }

    updateLayout() {
        // calculate layout of text
        this._target.textPanel.timeTextfield.y = this._target.textPanel.titleTextfield.y + this._target.textPanel.titleTextfield.getMeasuredHeight() + 40;
        this._target.textPanel.bodyTextfield.y = this._target.textPanel.timeTextfield.y + this._target.textPanel.timeTextfield.getMeasuredHeight() + 40;
        this._button.skin.y = this._target.textPanel.bodyTextfield.y + this._target.textPanel.bodyTextfield.getMeasuredHeight() + 100;
    }
};
